const getIsPartBucketQueryLoading = (store) => {
  return store.partCountBuckets.loading;
};

export { getIsPartBucketQueryLoading };
